module.exports = __webpack_public_path__ + "img/linkedin.64110483.svg";